export const TOKEN_TIME = 'tokenTime';
export const TOKEN_TIME_VALUE = 1000 * 2 * 60 *60 ;// token有效期两小时

export const UploadPictures='https://gftest.redstone.com.cn'; //浏览图片路径

export const baiduAK='c6xg7ee1uiq8wjYTZOQBjyfcu8iCvSj0'; //百度ak